export default {
  allLogos: true,
  heroBackground: 'brandOne100',
  heroBackgroundDesktop: 'brandOne100',
  heroDescriptionVariant: 'headingSmall',
  heroFullWidth: false,
  heroPaddingHorizontal: 'xxLarge',
  heroPaddingVertical: 'xxLarge',
  heroBodyBorder: true,
  includeImageOverlay: false,
  minHeight: '592',
  imagePosition: '70% 50%',
} as const;
